import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchFilter',
  standalone: true,
  pure: false
})
export class SearchFilterPipe implements PipeTransform {
  // Overload 1: filter group titles
  transform(
    input: string[],
    searchText: string,
    groupedItems: { [key: string]: { fieldLabel: string; selected: boolean }[] }
  ): string[];
  // Overload 2: filter items within a group
  transform(
    input: { fieldLabel: string; selected: boolean }[],
    searchText: string,
    groupTitle: string
  ): { fieldLabel: string; selected: boolean }[];

  transform(input: any[], searchText: string, context: any): any[] {
    if (!searchText?.trim()) {return input};
    const lower = searchText.toLowerCase();

    // Item-level filtering: context is a string (groupTitle)
    if (typeof context === 'string') {
      // If the group title itself matches, show all items in the group
      if (context.toLowerCase().includes(lower)) {return input};
      // Otherwise only show items whose label matches
      return input.filter((item: { fieldLabel: string }) =>
        item.fieldLabel.toLowerCase().includes(lower)
      );
    }

    // Group-level filtering: context is groupedItems map
    return input.filter((title: string) =>
      title.toLowerCase().includes(lower) ||
      context[title]?.some((item: { fieldLabel: string }) => item.fieldLabel.toLowerCase().includes(lower))
    );
  }
}
